import React from "react";
import { Button, Loader } from "@launchmetrics/lm-ui";
import CsvDownloader from 'react-csv-downloader';
import { DownloadOutline } from '@launchmetrics/lm-icons';

// Info about ExportCSV package: https://www.npmjs.com/package/react-csv-downloader

const ExportCSV = (props) => {

	const {buttonText, ...exportProps} = { ...props };

	if (!exportProps.separator) {
		exportProps.separator = ";";
	}

	return (
			<CsvDownloader className="text-right" {...exportProps} >
				<Button color="info" type="submit" size="small" className="mb-1" disabled={props.disabled}>
					<DownloadOutline />{buttonText} {props.disabled && <Loader styleProps={{ marginLeft: '10px'}}size={20} />}
				</Button>
			</CsvDownloader>
	);
};

export default ExportCSV;
